module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page-informations__container c-page--container c-marg--before-footer u-relative"
  }, [_c('app-title', {
    staticClass: "c-big-title",
    attrs: {
      "logo": _vm.contentGlobal.secondaryLogo,
      "title": _vm.contentPage.title
    }
  }), _vm._v(" "), _vm._l((_vm.contentPage.content), function(block, i) {
    return (_vm.contentPage.content) ? _c('div', {
      staticClass: "u-relative u-color--gray-light",
      class: {
        'c-page--container': block.type !== 'img'
      }
    }, [(block.type === 'img') ? _c('app-parallax', {
      attrs: {
        "velocity": -0.1
      }
    }, [_c('app-img', {
      staticClass: "u-block u-marg-b-xxl",
      class: ['c-html-img--' + block.align],
      attrs: {
        "src": block.src,
        "alt": block.alt
      },
      on: {
        "load": _vm._onContentResized
      }
    })], 1) : _vm._e(), _vm._v(" "), (block.type === 'img') ? _c('app-parallax', {
      attrs: {
        "velocity": -0.1
      }
    }, [_c('app-img', {
      staticClass: "u-block u-marg-b-xxl",
      class: ['c-html-img--' + block.align],
      attrs: {
        "src": block.src,
        "alt": block.alt
      },
      on: {
        "load": _vm._onContentResized
      }
    })], 1) : (block.type === 'small_img') ? _c('div', {
      staticClass: "c-html-text o-content t-text--xl u-marg-b-xxl u-line-height--md",
      class: ['c-html-text--' + block.align]
    }, [_c('img', {
      staticClass: "c-html-small_img",
      attrs: {
        "src": block.src,
        "alt": ""
      },
      on: {
        "load": _vm._onContentResized
      }
    })]) : (block.type === 'resume') ? _c('div', {
      staticClass: "c-html-resume o-content t-text--xl u-marg-b-xxl u-line-height--md",
      class: ['c-html-resume--' + block.align],
      domProps: {
        "innerHTML": _vm._s(block.text)
      }
    }) : (block.type === 'text') ? _c('div', {
      staticClass: "c-html-text o-content t-text--xl u-marg-b-xxl u-line-height--md",
      class: ['c-html-text--' + block.align],
      domProps: {
        "innerHTML": _vm._s(block.text)
      }
    }) : (block.type === 'resume') ? _c('div', {
      staticClass: "c-html-resume o-content t-text--xl u-marg-b-xxl u-line-height--md",
      class: ['c-html-resume--' + block.align],
      domProps: {
        "innerHTML": _vm._s(block.text)
      }
    }) : (block.type === 'text') ? _c('div', {
      staticClass: "c-html-text o-content t-text--xl u-marg-b-xxl u-line-height--md",
      class: ['c-html-text--' + block.align],
      domProps: {
        "innerHTML": _vm._s(block.text)
      }
    }) : (block.type === 'author') ? _c('div', {
      staticClass: "c-html-author t-text--xl o-content u-color--white u-bold",
      class: ['c-html-author--' + block.align]
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(block.text)
      }
    })]) : _vm._e(), _vm._v(" "), (i === 0) ? _c('div', {
      staticClass: "c-about-scroll--info u-marg-l-w6of9 u-w2of9 u-align-center u-hide@md"
    }, [_c('img', {
      staticClass: "u-marg-b-xxs",
      attrs: {
        "src": require("../../../assets/icon/icon-arrow-down--white-outline.png"),
        "alt": "Scroll down"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "u-block t-text--bold u-uppercase t-text--xxs",
      domProps: {
        "innerHTML": _vm._s(_vm.contentPage.taxonomies.scroll)
      }
    })]) : _vm._e()], 1) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14127042"}!./src/scripts/components/page-informations/template.html
// module id = 885
// module chunks = 0